module.exports = __webpack_public_path__ + "/img/7abd413bd34e2c7d087537b394666412.png";